import { request } from './request';
import { Response } from '../schemas/service';

const entrances = {
  async getEntrances() {
    try {
      // eslint-disable-next-line no-underscore-dangle
      const cacheData = window.__MAIN_FEATURE_ENTRANCE__;
      if (cacheData) {
        return cacheData;
      }
      const response: Response<any> = await request(
        {
          url: '/health/api/v1/home/queryMainFeatureEntrance',
          method: 'GET'
        },
        {}
      );
      const { result } = response; // true表示要弹窗
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};
export default entrances;
